module.exports = __webpack_public_path__ + "static/img/shenhe2.5a92698.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shenhe2.png
// module id = No4K
// module chunks = 1